import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import WhiteBox from "@/components/WhiteBox.vue";
import Modal from "@/components/Modal.vue";
import User from "@/types/User/User";
import ClosedReportDate from "@/components/ClosedReportDate.vue";
import CreateUserDialog from "./Modals/CreateUserDialog.vue";
import ImpersonationButton from "./ImpersonationButton.vue";
import DatePickerTextbox from "./DatePickerTextbox.vue";
import moment from "moment";
import UserList from "@/types/User/UserList";
import UserTariffDialog from "@/components/Modals/UserTariffDialog.vue";
// userId
// email
// firstName
// lastName
// from
// to
let ExternalConsultantsEditor = class ExternalConsultantsEditor extends Vue {
    shortDate(date) {
        return window.dateHandler.formatDateNoTime(date);
    }
    loadExternalConsultants() {
        this.$data.filteredExternalConsultants = null;
        this.$data.loadingExternalConsultants = true;
        this.$store
            .dispatch("adminGetAllExternalConsultants")
            .then((result) => {
            this.$data.consultants = result.data;
            this.filterCurrentConsultants();
            this.$data.loadingExternalConsultants = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/ExternalConsultantsEditor.vue - loadExternalConsultants");
        });
    }
    impersonateUser(userItem) {
        //Retrieve the user object
        this.$store
            .dispatch("getUser", userItem.userId)
            .then((result) => {
            const impersonateUser = new User(userItem);
            this.$store.dispatch("impersonateUser", impersonateUser);
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/ExternalConsultantsEditor.vue -> impersonateUser");
        });
    }
    isCurrentConsultant(consultant) {
        return (moment(new Date()) <= moment(consultant.to) || consultant.to === null);
    }
    filterCurrentConsultants() {
        if (this.$data.onlyCurrentConsultants === true) {
            this.$data.filteredExternalConsultants = this.$data.consultants.filter((consultant) => {
                return this.isCurrentConsultant(consultant);
            });
        }
        else {
            this.$data.filteredExternalConsultants = this.$data.consultants;
        }
    }
    showEditModal(item) {
        this.$data.selectedExternalConsultant = item;
        this.$data.modals.editExternalConsultantModal = true;
    }
    showAddModal(item) {
        this.loadUsers();
        this.$data.selectedExternalConsultantToAdd = null;
        this.$data.createExternalConsultantDates = { from: null, to: null };
        this.$data.modals.addExternalConsultantModal = true;
    }
    closeAddModal() {
        this.$data.selectedExternalConsultantToAdd = null;
        this.$data.createExternalConsultantDates = { from: null, to: null };
        this.$data.userList = null;
        this.$data.modals.addExternalConsultantModal = false;
    }
    updateCreateUser(value) {
        //recieve the event from the child to determine if we should close the modal (part of the "createUserDialog")
        this.$data.showCreateUserDialog = value;
    }
    updateEditExternalConsultant(value) {
        //recieve the event from the child to determine if we should close the modal (part of the "editEmployeeDialog")
        this.$data.modals.editExternalConsultantModal = value;
    }
    addExternalConsultant() {
        this.$data.selectedExternalConsultantToAdd.from = this.$data.createExternalConsultantDates.from;
        this.$data.selectedExternalConsultantToAdd.to = this.$data.createExternalConsultantDates.to;
        this.$store
            .dispatch("createExternalConsultantAsync", this.$data.selectedExternalConsultantToAdd)
            .then((result) => {
            this.loadExternalConsultants();
            this.$data.modals.addExternalConsultantModal = false;
            this.$data.selectedExternalConsultantToAdd = null;
            this.$data.createExternalConsultantDates = { from: null, to: null };
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/ExternalConsultantsEditor.vue -> addExternalConsultant");
        });
    }
    loadUsers() {
        this.$data.loadingUsers = true;
        this.$store
            .dispatch("getAllUsers")
            .then((result) => {
            this.$data.userList = new UserList(result.data);
            this.$data.loadingUsers = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/ExternalConsultantsEditor.vue - loadUsers");
        });
    }
    updateExternalConsultant() {
        this.$store
            .dispatch("updateExternalConsultant", this.$data.selectedExternalConsultant)
            .then((result) => {
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "The external consultant " +
                    this.$data.selectedExternalConsultant.firstName +
                    " " +
                    this.$data.selectedExternalConsultant.lastName +
                    " has been updated",
            });
            this.$data.modals.editExternalConsultantModal = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/ExternalConsultantsEditor.vue -> updateExternalConsultant");
        });
    }
    //send api call to remove the consultant
    deleteExternalConsultant() {
        this.$store
            .dispatch("deleteExternalConsultantAsync", this.$data.selectedExternalConsultant)
            .then((response) => {
            this.loadExternalConsultants();
            this.$data.showDeleteExternalConsultantDialog = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/ExternalConsultantsEditor.vue - deleteExternalConsultant");
        });
        this.$data.modals.editExternalConsultantModal = false;
    }
    showTariffModal(userItem) {
        this.$data.selectedExternalConsultant = userItem; // the refence used for the user in the component gets updated
        this.$data.showUserTariffDialog = true;
    }
};
ExternalConsultantsEditor = __decorate([
    Component({
        props: ["impUsers"],
        data() {
            return {
                theme: this.$store.getters.getTheme,
                filter: "",
                onlyCurrentConsultants: true,
                userList: null,
                consultants: null,
                loadingExternalConsultants: null,
                filteredExternalConsultants: null,
                selectedExternalConsultantToAdd: null,
                modals: {
                    addExternalConsultantModal: false,
                    editExternalConsultantModal: false,
                },
                selectedExternalConsultant: null,
                showDeleteExternalConsultantDialog: false,
                createExternalConsultantDates: { from: null, to: null },
                sortbyValue: "email",
                showUserTariffDialog: false,
                showCreateUserDialog: false,
                externalConsultantHeaders: [
                    { text: "Name", value: "email", sortable: true, divider: true },
                    { text: "Closed Reports", value: "closedReportsDate", align: "center", divider: true },
                    { text: "Impersonate", value: "impersonate", sortable: false },
                    { text: "Tariffs", value: "tariffs", sortable: false },
                    { text: "Edit", value: "edit", sortable: false },
                ],
                employeeTypes: [
                    { text: "Prospect", value: "Prospect" },
                    { text: "Level", value: "Level" },
                    { text: "Fixed", value: "Fixed" },
                    { text: "TeamManager", value: "TeamManager" },
                ],
                impersonateText: "Impersonate",
            };
        },
        created() {
            this.loadExternalConsultants();
        },
        components: {
            WhiteBox,
            Modal,
            ClosedReportDate,
            CreateUserDialog,
            ImpersonationButton,
            DatePickerTextbox,
            UserTariffDialog,
        },
    })
], ExternalConsultantsEditor);
export default ExternalConsultantsEditor;
